import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { Timer, ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <SectionWrapper id="pricing" className="relative" data-id="element-235">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyber-neon/5 rounded-full blur-[120px] pointer-events-none" data-id="element-236"></div>

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-237">
        <p className="text-gray-300 mb-8 text-lg" data-id="element-238">
          Sabemos que como estudiante o joven en LATAM, cada dólar cuenta. Por
          eso, y solo por las próximas 24 horas como parte de nuestro
          lanzamiento regional:
        </p>

        <div className="bg-cyber-dark border-2 border-cyber-neon rounded-2xl p-8 md:p-12 shadow-neon-strong relative overflow-hidden" data-id="element-239">
          {/* Scanline effect inside pricing card */}
          <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.25)_50%)] bg-[length:100%_4px] pointer-events-none opacity-20" data-id="element-240"></div>

          <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-cyber-neon text-cyber-black font-bold font-mono text-sm px-6 py-1 rounded-b-lg" data-id="element-241">
            OFERTA DE LANZAMIENTO
          </div>

          <div className="mt-6 mb-2" data-id="element-242">
            <span className="text-gray-500 font-mono text-xl line-through decoration-cyber-red decoration-2" data-id="element-243">
              Precio Normal: $42.50
            </span>
          </div>

          <div className="mb-6 flex items-center justify-center gap-4" data-id="element-244">
            <h3 className="text-6xl md:text-7xl font-bold font-mono text-cyber-neon text-shadow-neon-strong" data-id="element-245">
              $6.36 <span className="text-2xl text-cyber-neon/70" data-id="element-246">USD</span>
            </h3>
          </div>

          <p className="text-gray-400 italic mb-8" data-id="element-247">
            *(Menos de lo que cuesta una salida a comer que igual te da
            ansiedad).*
          </p>

          <motion.div animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-248">
            <NeonButton size="lg" fullWidth href="https://www.tumomentovital.com/cart/47625937879232:1" className="text-xl py-6 flex items-center justify-center gap-3" data-id="element-249">
              ACCESO INMEDIATO <ArrowRight className="w-6 h-6" data-id="element-250" />
            </NeonButton>
          </motion.div>

          <div className="mt-6 flex items-center justify-center gap-2 text-cyber-red font-mono text-sm" data-id="element-251">
            <Timer className="w-4 h-4 animate-pulse" data-id="element-252" />
            <span data-id="element-253">Esta oferta es para los primeros 50 compradores de hoy.</span>
          </div>
          <p className="text-gray-500 text-xs mt-2" data-id="element-254">
            Una vez se agoten los cupos, el precio subirá automáticamente.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}